module.exports = __webpack_public_path__ + "static/media/1011647.b6af56a3.png";